import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const shortFaqs = [
  {
    question: "Was kostet eine Fassadendämmung (WDVS) in Herford?",
    answer: "Die Kosten hängen von Materialwahl (EPS, Mineralwolle, Resol) und dem Zustand Ihrer Fassade ab. Wir bieten Ihnen einen kostenlosen Vor-Ort-Check an und erstellen ein transparentes, individuelles Angebot."
  },
  {
    question: "Welche Innendämmung hilft sicher gegen Schimmel?",
    answer: "Wir setzen primär auf Calciumsilikatplatten, da diese feuchtigkeitsregulierend und rein mineralisch sind. Das alkalische Material entzieht Schimmel dauerhaft den Nährboden – bewährt seit Jahren in Herford."
  },
  {
    question: "Bieten Sie kostenlose Besichtigungen an?",
    answer: "Ja, im gesamten Kreis Herford beraten wir Sie unverbindlich vor Ort. Innerhalb von 24 Stunden melden wir uns bei Ihnen zurück – das ist unser Rückruf-Versprechen."
  },
  {
    question: "Welche Förderungen gibt es für Fassadendämmung in Herford?",
    answer: "Für eine energetische Sanierung mit WDVS können Sie in Herford mehrere Förderungen nutzen. Das BEG (Bundesförderung für effiziente Gebäude) über die KfW bezuschusst Dämmmaßnahmen mit bis zu 20 % der förderfähigen Kosten. Zusätzlich gibt es BAFA-Förderung für Einzelmaßnahmen. Wir beraten Sie im Rahmen unseres kostenlosen Fassaden-Checks zu allen aktuellen Fördermöglichkeiten."
  },
  {
    question: "In welchen Städten sind Sie tätig?",
    answer: "Wir sind in Herford und dem gesamten Kreis Herford tätig: Hiddenhausen, Löhne, Bünde, Enger, Spenge, Bad Oeynhausen, Vlotho und Kirchlengern. Auch im Raum Bielefeld, Detmold, Lemgo und Bad Salzuflen führen wir Aufträge durch."
  },
  {
    question: "Wie lange dauert eine Fassadensanierung?",
    answer: "Eine typische Fassadensanierung eines Einfamilienhauses dauert je nach Größe und Umfang zwischen 1 und 3 Wochen. Ein WDVS-Komplettsystem (Dämmung + Putz + Anstrich) kann bei größeren Objekten auch 3–4 Wochen in Anspruch nehmen. Wir planen jeden Auftrag so, dass Sie schnellstmöglich wieder uneingeschränkt in Ihrem Zuhause leben können."
  },
  {
    question: "Führen Sie auch Arbeiten in Mietwohnungen durch?",
    answer: "Ja, wir arbeiten regelmäßig in Mietwohnungen – sowohl für Eigentümer als auch für Vermieter und Hausverwaltungen in Herford und Umgebung. Wir kennen die besonderen Anforderungen: schnelle Ausführung, geringe Belastung für Mieter und saubere Baustelle."
  },
  {
    question: "Was unterscheidet Malerfachbetrieb Stein von anderen Malern in Herford?",
    answer: "Als meistergeführter Fachbetrieb seit 2014 liegt unser Schwerpunkt auf energetischer Sanierung und hochwertigen Oberflächen – nicht nur auf einfachem Streichen. Wir beherrschen WDVS-Systeme, Calciumsilikat-Innendämmung, Mikrozement und exklusive Spachteltechniken. Das macht uns zum Spezialisten, nicht zum Allround-Maler."
  }
];

export const FAQShort = () => {
  return (
    <section className="py-16 md:py-24 lg:py-32 bg-muted/20">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4 block">
            Häufige Fragen
          </span>
          <h2 className="font-caslon text-3xl md:text-4xl font-bold text-foreground">
            Häufige Fragen zu unseren Leistungen
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {shortFaqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-background border border-foreground/8 rounded-lg px-6"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5">
                <span className="font-semibold text-sm pr-4">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5 text-sm">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
